/** Formats metadata keys into readable labels while retaining meaningful acronyms. */
export const formatMetadataKey = (key: string): string => {
  const spacedKey = key
    .replace(/([a-z\d])([A-Z])/g, "$1 $2")
    .replace(/([A-Z]+)([A-Z][a-z])/g, "$1 $2");

  return spacedKey.charAt(0).toUpperCase() + spacedKey.slice(1);
};
